import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

function SongTweaks({ song }) {
  const { user, authToken } = useAuth();
  const [tweaks, setTweaks] = useState({
    h_length: song.h_length || 0,
    h_skip: song.h_skip || 0,
    h_fadeout: song.h_fadeout || 0,
  });

  const [saving, setSaving] = useState(false);
  const isHelperOrAbove = ['helper', 'moderator', 'admin'].includes(user?.role);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTweaks({ ...tweaks, [name]: parseInt(value) || 0 });
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(`/api/song/${song.id}/tweak`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(tweaks),
      });

      if (!res.ok) throw new Error('Failed to save tweaks');
      alert('Saved!');
    } catch (err) {
      console.error(err);
      alert('Error saving tweaks');
    } finally {
      setSaving(false);
    }
  };

  if (!isHelperOrAbove) return null;

  return (
    <div className="mt-4 p-2 border rounded bg-gray-50">
      <h3 className="font-bold mb-2">Helper Tweaks</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {['h_length', 'h_skip', 'h_fadeout'].map((field) => (
          <label key={field} className="flex flex-col text-sm">
            {field}:
            <input
              type="number"
              name={field}
              value={tweaks[field]}
              onChange={handleChange}
              className="mt-1 p-1 border rounded"
            />
          </label>
        ))}
      </div>
      <button
        className="mt-3 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
        onClick={handleSave}
        disabled={saving}
      >
        {saving ? 'Saving…' : 'Save'}
      </button>
    </div>
  );
}

export default SongTweaks;
